import { ElementRef, EventEmitter, TemplateRef, ViewContainerRef } from '@angular/core';
import { SessionService } from '../session/session.service';
import { ActionPlanService } from "../action-plan/action-plan.service";
import { BaseComponent } from "../../shared/base.component";
import { SessionStorageService } from "ngx-webstorage";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { OfflineMessageService } from "../offline-message/offline-message.service";
import { UserService } from "../../core/user/user.service";
import { MessageService } from "../message/message.service";
import { TranslateService } from "@ngx-translate/core";
import { debug } from "../../app.constants";
import { ConversationnService } from "../conversationn/conversationn.service";
import { SRQCompletedService } from "../srq-completed/srq-completed.service";
import { Router } from "@angular/router";
import { NavbarInukaService } from "../navbar-inuka/navbar-inuka.service";
import { CoachNavbarNotificationComponent } from "./coach-navbar-notification/coach-navbar-notification.component";
import { UpdateTimezoneNavbarNotificationComponent } from "../update-timezone-navbar-notification/update-timezone-navbar-notification.component";
import { SessionStatusManagerService } from "../../core/session/session-status-manager.service";
import { TimeZoneService } from "../../core/util/timzone.service";
import { PwaInstallationService } from "../../shared/pwa-installation/pwa-installation.service";
import { JhiAlertService, JhiEventManager } from "../../ng-jhipster/service";
import * as i0 from "@angular/core";
import * as i1 from "../session/session.service";
import * as i2 from "../action-plan/action-plan.service";
import * as i3 from "../../ng-jhipster/service";
import * as i4 from "ngx-webstorage";
import * as i5 from "@ng-bootstrap/ng-bootstrap";
import * as i6 from "../offline-message/offline-message.service";
import * as i7 from "../../core/user/user.service";
import * as i8 from "../conversationn/conversationn.service";
import * as i9 from "../message/message.service";
import * as i10 from "@ngx-translate/core";
import * as i11 from "../srq-completed/srq-completed.service";
import * as i12 from "@angular/router";
import * as i13 from "../navbar-inuka/navbar-inuka.service";
import * as i14 from "../../core/session/session-status-manager.service";
import * as i15 from "../../core/util/timzone.service";
import * as i16 from "../../shared/pwa-installation/pwa-installation.service";
import * as i17 from "../../shared/user-info/user-info.component";
import * as i18 from "./upcoming-session/upcoming-session.component";
import * as i19 from "@angular/common";
import * as i20 from "../../ng-jhipster/language/jhi-translate.directive";
import * as i21 from "../session/conversation-list/conversation-list.component";
import * as i22 from "./upcoming-sessions/upcoming-sessions.component";
import * as i23 from "../session/session-chat-user/session-control-dropdown/session-control-dropdown.component";
import * as i24 from "../video-call/in-progress-video-call-indicator/in-progress-video-call-indicator.component";
import * as i25 from "@angular/material/tooltip";
import * as i26 from "../session/chat-ui-new/chat-ui-new.component";
import * as i27 from "../session/chat-ui/message-send/session-message-send.component";
import * as i28 from "../session/session-chat-coach/inuka-journey-coach-chat/inuka-journey-coach-chat.component";
import * as i29 from "./action-plan-list/action-plan-list.component";
import * as i30 from "../session/session-chat-coach/coach-user-note/coach-user-note.component";
import * as i31 from "../../shared/pwa-installation/pwa-installation-ios/pwa-installation-ios.component";
import * as i32 from "../../shared/modal-success/modal-success.component";
import * as i33 from "@fortawesome/angular-fontawesome";
import * as i34 from "../session/session-chat-coach/previous-session-transcript-popup/previous-session-transcript-popup.component";
const _c0 = ["emailSessionMessagesModal"];
const _c1 = ["previousSessionTranscriptModal"];
const _c2 = ["upcomingSessionBoxElement"];
const _c3 = ["mobileViewEmbeddedComponentContainer"];
function IndexCoachComponent_button_15_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 29);
    i0.ɵɵlistener("click", function IndexCoachComponent_button_15_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r10); const ctx_r9 = i0.ɵɵnextContext(); return ctx_r9.navigateToSession(); });
    i0.ɵɵtext(1, "Chat With Client");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("d-none", ctx_r1.viewMode !== "UserInfo")("d-block", ctx_r1.viewMode === "UserInfo");
} }
function IndexCoachComponent_div_30_div_8_session_message_send_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "session-message-send", 57);
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("session", ctx_r16.session)("message", ctx_r16.message)("messageToBeReplied", ctx_r16.messageToBeReplied)("maxCharacterSize", 3000);
} }
function IndexCoachComponent_div_30_div_8_div_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 58);
} }
const _c4 = function (a0) { return { height: a0 }; };
function IndexCoachComponent_div_30_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r19 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 39);
    i0.ɵɵelementStart(1, "div", 40);
    i0.ɵɵelementStart(2, "div", 41);
    i0.ɵɵelementStart(3, "div", 42);
    i0.ɵɵelementStart(4, "session-control-dropdown", 43);
    i0.ɵɵlistener("resourceSelected", function IndexCoachComponent_div_30_div_8_Template_session_control_dropdown_resourceSelected_4_listener($event) { i0.ɵɵrestoreView(_r19); const ctx_r18 = i0.ɵɵnextContext(2); return ctx_r18.onResourceSelected($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 44);
    i0.ɵɵelementStart(6, "div", 45);
    i0.ɵɵelement(7, "in-progress-video-call-indicator", 46);
    i0.ɵɵelementStart(8, "div", 47);
    i0.ɵɵpipe(9, "translate");
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(10, "svg", 48);
    i0.ɵɵelement(11, "use", 49);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(12, "div", 50, 51);
    i0.ɵɵelementStart(14, "div", 52);
    i0.ɵɵelementStart(15, "chat-ui-new", 53);
    i0.ɵɵlistener("scrolledToBottom", function IndexCoachComponent_div_30_div_8_Template_chat_ui_new_scrolledToBottom_15_listener($event) { i0.ɵɵrestoreView(_r19); const ctx_r20 = i0.ɵɵnextContext(2); return ctx_r20.onScrolledToBottom($event); })("repliedMessage", function IndexCoachComponent_div_30_div_8_Template_chat_ui_new_repliedMessage_15_listener($event) { i0.ɵɵrestoreView(_r19); const ctx_r21 = i0.ɵɵnextContext(2); return ctx_r21.repliedMessage($event); })("firstSessionMessageOutput", function IndexCoachComponent_div_30_div_8_Template_chat_ui_new_firstSessionMessageOutput_15_listener($event) { i0.ɵɵrestoreView(_r19); const ctx_r22 = i0.ɵɵnextContext(2); return ctx_r22.firstSessionMessageOutput($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "div", null, 54);
    i0.ɵɵtemplate(18, IndexCoachComponent_div_30_div_8_session_message_send_18_Template, 1, 4, "session-message-send", 55);
    i0.ɵɵtemplate(19, IndexCoachComponent_div_30_div_8_div_19_Template, 1, 0, "div", 56);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r14 = i0.ɵɵreference(13);
    const _r15 = i0.ɵɵreference(17);
    i0.ɵɵnextContext();
    const _r11 = i0.ɵɵreference(1);
    const _r12 = i0.ɵɵreference(3);
    const ctx_r13 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(15, _c4, _r11.offsetHeight - _r12.offsetHeight + "px"));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("session", ctx_r13.session)("hideCancelReschedule", true);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("session", ctx_r13.session);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("routerLink", "/session/chat-coach/" + ctx_r13.session.id);
    i0.ɵɵproperty("matTooltip", i0.ɵɵpipeBind1(9, 13, "sessionChat.paragraph.expandInfo"))("matTooltipPosition", "below")("matTooltipClass", "expand-tool-tip");
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(17, _c4, _r14.offsetHeight - _r15.offsetHeight + "px"));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("session", ctx_r13.session)("viewportHeight", "100%");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r13.isCoachAllowedSendMessageToUser == true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r13.isCoachAllowedSendMessageToUser == false);
} }
function IndexCoachComponent_div_30_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 30, 31);
    i0.ɵɵelementStart(2, "div", 32, 33);
    i0.ɵɵelementStart(4, "div", 34);
    i0.ɵɵelementStart(5, "div", 35);
    i0.ɵɵelementStart(6, "div", 36);
    i0.ɵɵelement(7, "user-info", 37);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(8, IndexCoachComponent_div_30_div_8_Template, 20, 19, "div", 38);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("user", ctx_r2.selectedUser)("srqHistory", ctx_r2.srqHistory)("session", ctx_r2.session);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.session);
} }
function IndexCoachComponent_div_31_div_9_inuka_journey_coach_chat_14_Template(rf, ctx) { if (rf & 1) {
    const _r30 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "inuka-journey-coach-chat", 76);
    i0.ɵɵlistener("sessionSelectedToOpenInThisTab", function IndexCoachComponent_div_31_div_9_inuka_journey_coach_chat_14_Template_inuka_journey_coach_chat_sessionSelectedToOpenInThisTab_0_listener($event) { i0.ɵɵrestoreView(_r30); const ctx_r29 = i0.ɵɵnextContext(3); return ctx_r29.showPreviousSessionTranscriptInThisTab($event); })("sessionSelectedToOpenInNewTab", function IndexCoachComponent_div_31_div_9_inuka_journey_coach_chat_14_Template_inuka_journey_coach_chat_sessionSelectedToOpenInNewTab_0_listener($event) { i0.ɵɵrestoreView(_r30); const ctx_r31 = i0.ɵɵnextContext(3); return ctx_r31.showPreviousSessionTranscriptInNewTab($event); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r26 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("sessions", ctx_r26.selectedUserSessions)("srqHistory", ctx_r26.srqHistory);
} }
function IndexCoachComponent_div_31_div_9_action_plan_list_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "action-plan-list", 77);
} if (rf & 2) {
    const ctx_r27 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("userId", ctx_r27.selectedUser.id);
} }
function IndexCoachComponent_div_31_div_9_div_16_Template(rf, ctx) { if (rf & 1) {
    const _r33 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 78);
    i0.ɵɵelementStart(1, "div", 79);
    i0.ɵɵelementStart(2, "div", 80);
    i0.ɵɵlistener("click", function IndexCoachComponent_div_31_div_9_div_16_Template_div_click_2_listener() { i0.ɵɵrestoreView(_r33); const ctx_r32 = i0.ɵɵnextContext(3); return ctx_r32.goToLink("/#/notes/" + ctx_r32.session.user.id + "/" + ctx_r32.session.coachId); });
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(4, "svg", 81);
    i0.ɵɵelement(5, "use", 49);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelement(6, "coach-user-note", 82);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r28 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("matTooltip", i0.ɵɵpipeBind1(3, 6, "sessionChat.paragraph.expandInfoNotes"))("matTooltipPosition", "below")("matTooltipClass", "expand-tool-tip");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("isEmbedded", true)("coachId", ctx_r28.currentCoach.id)("userId", ctx_r28.selectedUser.id);
} }
function IndexCoachComponent_div_31_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r35 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 66);
    i0.ɵɵelementStart(1, "div", 7);
    i0.ɵɵelementStart(2, "div", 67);
    i0.ɵɵlistener("click", function IndexCoachComponent_div_31_div_9_Template_div_click_2_listener() { i0.ɵɵrestoreView(_r35); const ctx_r34 = i0.ɵɵnextContext(2); return ctx_r34.switchRightColumnTab("journey"); });
    i0.ɵɵelementStart(3, "h5", 68);
    i0.ɵɵtext(4, "Journey");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 67);
    i0.ɵɵlistener("click", function IndexCoachComponent_div_31_div_9_Template_div_click_5_listener() { i0.ɵɵrestoreView(_r35); const ctx_r36 = i0.ɵɵnextContext(2); return ctx_r36.switchRightColumnTab("actionPlans"); });
    i0.ɵɵelementStart(6, "h5", 69);
    i0.ɵɵtext(7, "Action Plans");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 67);
    i0.ɵɵlistener("click", function IndexCoachComponent_div_31_div_9_Template_div_click_8_listener() { i0.ɵɵrestoreView(_r35); const ctx_r37 = i0.ɵɵnextContext(2); return ctx_r37.switchRightColumnTab("notes"); });
    i0.ɵɵelementStart(9, "h5", 70);
    i0.ɵɵtext(10, "Notes");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(11, "hr", 19);
    i0.ɵɵelementStart(12, "div", 71);
    i0.ɵɵelementStart(13, "div", 72);
    i0.ɵɵtemplate(14, IndexCoachComponent_div_31_div_9_inuka_journey_coach_chat_14_Template, 1, 2, "inuka-journey-coach-chat", 73);
    i0.ɵɵtemplate(15, IndexCoachComponent_div_31_div_9_action_plan_list_15_Template, 1, 1, "action-plan-list", 74);
    i0.ɵɵtemplate(16, IndexCoachComponent_div_31_div_9_div_16_Template, 7, 8, "div", 75);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r23 = i0.ɵɵreference(2);
    const _r24 = i0.ɵɵreference(4);
    const ctx_r25 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(10, _c4, _r23.offsetHeight - _r24.offsetHeight + "px"));
    i0.ɵɵadvance(2);
    i0.ɵɵclassProp("selected-tab", ctx_r25.rightColumnTab === "journey");
    i0.ɵɵadvance(3);
    i0.ɵɵclassProp("selected-tab", ctx_r25.rightColumnTab === "actionPlans");
    i0.ɵɵadvance(3);
    i0.ɵɵclassProp("selected-tab", ctx_r25.rightColumnTab === "notes");
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngIf", ctx_r25.rightColumnTab === "journey");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r25.rightColumnTab === "actionPlans");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r25.rightColumnTab === "notes");
} }
function IndexCoachComponent_div_31_Template(rf, ctx) { if (rf & 1) {
    const _r39 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 59);
    i0.ɵɵelementStart(1, "div", 60, 61);
    i0.ɵɵelementStart(3, "div", 32, 62);
    i0.ɵɵelementStart(5, "div", 63);
    i0.ɵɵelementStart(6, "div", 7);
    i0.ɵɵelementStart(7, "div", 64);
    i0.ɵɵelementStart(8, "upcoming-session", 12);
    i0.ɵɵlistener("onSessionSchedulerToggle", function IndexCoachComponent_div_31_Template_upcoming_session_onSessionSchedulerToggle_8_listener($event) { i0.ɵɵrestoreView(_r39); const ctx_r38 = i0.ɵɵnextContext(); return ctx_r38.showSessionScheduler = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, IndexCoachComponent_div_31_div_9_Template, 17, 12, "div", 65);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵclassProp("h-100", ctx_r3.showSessionScheduler);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("user", ctx_r3.selectedUser)("coach", ctx_r3.currentCoach)("session", ctx_r3.upcomingSession)("sessionToReschedule", ctx_r3.sessionToReschedule);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r3.showSessionScheduler);
} }
function IndexCoachComponent_pwa_installation_ios_32_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "pwa-installation-ios");
} }
function IndexCoachComponent_ng_template_33_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "modal-success", 83);
    i0.ɵɵpipe(1, "translate");
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵproperty("titleText", "sessionChat.header.selectedMessages")("message", i0.ɵɵpipeBind1(1, 2, ctx_r6.emailSessionMessagesModalMessage));
} }
function IndexCoachComponent_ng_template_35_Template(rf, ctx) { if (rf & 1) {
    const _r43 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 84);
    i0.ɵɵelementStart(1, "div", 85);
    i0.ɵɵelementStart(2, "fa-icon", 86);
    i0.ɵɵlistener("click", function IndexCoachComponent_ng_template_35_Template_fa_icon_click_2_listener() { const restoredCtx = i0.ɵɵrestoreView(_r43); const modal_r41 = restoredCtx.$implicit; return modal_r41.dismiss("Cross click"); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 87);
    i0.ɵɵelement(4, "previous-session-transcript-popup", 88);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("showInModal", true)("session", ctx_r8.previousSessionToShowTranscript);
} }
export class IndexCoachComponent extends BaseComponent {
    constructor(sessionService, actionPlanService, eventManager, sessionStorage, modalService, offlineMessageService, userService, conversationnService, messageService, translate, alertService, srqCompletedService, elementRef, router, navbarInukaService, sessionStatusManagerService, timeZoneService, pwaInstallationService) {
        var _a, _b;
        super(sessionStorage, modalService);
        this.sessionService = sessionService;
        this.actionPlanService = actionPlanService;
        this.eventManager = eventManager;
        this.sessionStorage = sessionStorage;
        this.modalService = modalService;
        this.offlineMessageService = offlineMessageService;
        this.userService = userService;
        this.conversationnService = conversationnService;
        this.messageService = messageService;
        this.translate = translate;
        this.alertService = alertService;
        this.srqCompletedService = srqCompletedService;
        this.elementRef = elementRef;
        this.router = router;
        this.navbarInukaService = navbarInukaService;
        this.sessionStatusManagerService = sessionStatusManagerService;
        this.timeZoneService = timeZoneService;
        this.pwaInstallationService = pwaInstallationService;
        this.isMobileView = document.body.offsetWidth <= 992;
        this.display = this.isMobileView;
        this.message = '';
        this.firstSessionMessage = null;
        this.dropDownOptions = ['sessionChat.paragraph.current', 'sessionChat.paragraph.past', 'sessionChat.paragraph.wellbeing', 'sessionChat.paragraph.emailSelected'];
        this.secondColumnContent = this.dropDownOptions[0];
        this.messageSent = new EventEmitter();
        this.messagesList = [];
        // @ViewChild('rightColumnElement')
        // rightColumnElement: ElementRef;
        this.sessionActiveOrStarted = ((_a = this.session) === null || _a === void 0 ? void 0 : _a.active) || ((_b = this.session) === null || _b === void 0 ? void 0 : _b.started);
        this.showActionPlan = false;
        this.topNotSpecified = {};
        this.top24percent = { 'top': '24%' };
        this.leftColumnTab = "chats";
        this.rightColumnTab = "journey";
        this.viewMode = 'All';
    }
    get selectedUser() {
        return this._selectedUser;
    }
    set selectedUser(value) {
        var _a;
        if ((value === null || value === void 0 ? void 0 : value.id) !== ((_a = this._selectedUser) === null || _a === void 0 ? void 0 : _a.id)) {
            this._selectedUser = value;
            this.loadUserData(value);
        }
    }
    ngOnInit() {
        this.showPwaInstallation = this.pwaInstallationService.shouldShowPwaInstallation();
        console.log(document.body.offsetWidth);
        this.elementRef.nativeElement.ownerDocument.body.style.backgroundColor = '#F7F4EB';
        this.userService.current().subscribe(user => {
            this.isCoach = user.authorities.includes("ROLE_COACH");
            this.currentCoach = user;
            if (!this.timeZoneService.isUserAndBrowserTimezonesTheSame(user)) {
                this.navbarInukaService.showEmbeddedComponent(UpdateTimezoneNavbarNotificationComponent, {
                    user,
                    isCoach: this.isCoach
                });
            }
        });
        // this.sessionService.recentSessions().subscribe(
        //   (res: HttpResponse<ISession[]>) => {
        //     this.sessions = res.body;
        //     this.newSession = this.sessions[0];
        //     this.endedSessions = this.sessions.filter(s => s.status === 'ENDED');
        //   },
        //   () => this.onError()
        // );
        this.upcomingMessageIdEventSubscription = this.eventManager.subscribe('upcomingSessionId', (sessionId) => {
            this.getActionPlan(sessionId.content);
        });
        this.conversationListSubscription = this.eventManager.subscribe('conversationListRetrieved', (c) => {
            this.conversationCount = c.content;
        });
        this.messagesListSubscription = this.eventManager.subscribe('messagesList', (response) => {
            this.messagesList = response.content;
            console.log(this.messagesList);
        });
        this.sessionListModificationEventSubscription = this.eventManager.subscribe('sessionListModification', () => {
            if (this.selectedUser) {
                this.userService.findById(this.selectedUser.id).subscribe(user => this._selectedUser = user);
                this.loadUserSessions(this.selectedUser);
            }
        });
        this.organizationResourceSubscription = this.eventManager.subscribe('organizationResourceSelected', (response) => {
            console.log(response);
            this.message = response.content;
        });
        this.offlineMessageService.unreadMessageCount().subscribe(res => {
            this.unreadMessageCount = res.body;
            console.log("unreadMessageCount: " + this.unreadMessageCount);
        });
    }
    ngAfterViewInit() {
        super.ngAfterViewInit();
        this.navbarInukaService.registerAsEmbeddedComponentHost(this.mobileViewEmbeddedComponentContainer);
        this.sessionIsAboutToStartSubscription = this.sessionStatusManagerService.getSessionIsAboutToStartObservable().subscribe(session => {
            console.log('session is about to start');
            this.navbarInukaService.showEmbeddedComponent(CoachNavbarNotificationComponent, {
                session
            });
        });
        this.sessionStartedSubscription = this.sessionStatusManagerService.getSessionStartedObservable().subscribe(session => {
            console.log('session is started');
            this.navbarInukaService.showEmbeddedComponent(CoachNavbarNotificationComponent, {
                session
            });
        });
    }
    getActionPlan(sessionId) {
        this.actionPlanService.findBySessionId(sessionId).subscribe((res) => {
            this.actionPlan = res.body;
            console.log(this.actionPlan);
            this.getSessionsByActionPlan(this.actionPlan.id);
        });
    }
    getSessionsByActionPlan(actionPlanId) {
        this.sessionService.sessionsForActionPlan(actionPlanId).subscribe((res) => {
            this.sessionsByActionPlan = res.body.sort((a, b) => (a.sessionStartTime > b.sessionStartTime ? -1 : 1));
            console.log(this.sessionsByActionPlan);
        }, () => this.onError());
    }
    onError() {
    }
    //  THIS GETS THE PERSISTENT SESSION FROM SESSION LIST CARD
    getPersistentSessionEmitted(session) {
        console.log(session);
        this.persistentSession = null;
        if (session != null) {
            this.persistentSession = session;
        }
        // else {
        //   this.navbarInukaService.hideEmbeddedComponent();
        // }
    }
    //  THIS GETS THE SELECTED ITEM FROM SESSION LIST CARD
    getSessionItemSelected(session) {
        console.log(session);
        if (session != null) {
            this.session = session;
            if (this.selectedUser === null || this.selectedUser === undefined || this.selectedUser.id !== this.session.user.id) {
                this.selectedUser = this.session.user;
                this.conversation = null;
            }
        }
    }
    //  THIS GETS THE SELECTED ITEM FROM CONVERSATION LIST CARD
    getConversationItemSelected(conversation) {
        console.log(conversation);
        // if there is no previous value for this.conversation, it means this is the first conversation that is selected automatically
        // if there is a value for this.conversation, it means the user has selected this conversation manually
        this.isConversationAutomaticallySelected = !this.conversation;
        this.conversation = conversation;
        if (this.isConversationAutomaticallySelected && !this.isScreenLg) {
            // there is no need to automatically select the conversation on mobile size
            return;
        }
        if (!this.selectedUser || this.selectedUser.id !== this.conversation.user.id) {
            this.selectedUser = this.conversation.user;
            this.session = null;
        }
    }
    smoothScrollToElement(elementId) {
        console.log(elementId);
        window.setTimeout(() => {
            let element;
            let parent;
            if (this.windowWidth < 768) {
                element = document.getElementById(elementId + '-small');
                parent = document.getElementById('schedule-session-small');
            }
            else if (this.windowWidth >= 768 && this.windowWidth < 1200) {
                element = document.getElementById(elementId + '-medium');
                parent = document.getElementById('schedule-session-medium');
            }
            else if (this.windowWidth > 1200) {
                element = document.getElementById(elementId + '-big');
                parent = document.getElementById('schedule-session-big');
            }
            else {
                debug('Can not define HTML element to scroll to: ' + elementId);
                return;
            }
            parent.scrollTop = element.offsetTop;
        }, 100);
    }
    //  THIS GETS THE SCHEDULED SESSION FROM SCHEDULED SESSION COMPONENT
    getScheduledSession(event) {
        console.log(event);
        this.newSession = event;
        this.selectedUser = event.user;
    }
    getScheduledSessionText(event) {
        this.scheduleSessionText = null;
        console.log(event);
        this.scheduleSessionText = event;
    }
    setSelectedUser(event) {
        this.getConversationItemSelected(event);
    }
    messageSave(event) {
        this.messageSent.emit(event);
    }
    firstSessionMessageOutput(message) {
        if (message != null) {
            if (this.firstSessionMessage === null || this.firstSessionMessage.id !== message.id) {
                this.firstSessionMessage = message;
                this.getActionPlan(this.firstSessionMessage.sessionId);
            }
        }
    }
    repliedMessage(message) {
        this.messageToBeReplied = message;
        console.log(this.messageToBeReplied);
    }
    onScrolledToBottom(o) {
        this.scrolledToBottom = o;
        this.display = true;
    }
    displayActionPlan() {
        this.showActionPlan = true;
    }
    closeActionPlan() {
        this.showActionPlan = false;
    }
    ngOnDestroy() {
        if (this.messagesListSubscription) {
            this.messagesListSubscription.unsubscribe();
        }
        if (this.upcomingMessageIdEventSubscription) {
            this.upcomingMessageIdEventSubscription.unsubscribe();
        }
        if (this.conversationListSubscription) {
            this.conversationListSubscription.unsubscribe();
        }
        if (this.sessionListModificationEventSubscription) {
            this.sessionListModificationEventSubscription.unsubscribe();
        }
        if (this.organizationResourceSubscription) {
            this.organizationResourceSubscription.unsubscribe();
        }
        if (this.sessionIsAboutToStartSubscription) {
            this.sessionIsAboutToStartSubscription.unsubscribe();
        }
        if (this.sessionStartedSubscription) {
            this.sessionStartedSubscription.unsubscribe();
        }
        this.navbarInukaService.hideEmbeddedComponent();
    }
    checkIsCoachAllowedSendMessageToUser(user) {
        this.isCoachAllowedSendMessageToUser = null;
        this.messageService.isCoachAllowedSendMessageToUser(user.id).subscribe(value => {
            var _a;
            if (((_a = this.selectedUser) === null || _a === void 0 ? void 0 : _a.id) === user.id) { // make sure the selected user isn't changed meanwhile the request
                this.isCoachAllowedSendMessageToUser = value.body;
            }
        });
    }
    loadSrqHistory(user) {
        this.srqCompletedService.srqHistoryByUser(user.id).subscribe((res) => {
            var _a;
            if (((_a = this.selectedUser) === null || _a === void 0 ? void 0 : _a.id) === user.id) { // make sure the selected user isn't changed meanwhile the request
                this.srqHistory = res.body;
            }
        });
    }
    loadUserData(user) {
        this.checkIsCoachAllowedSendMessageToUser(user);
        this.loadUserSessions(user);
        this.loadSrqHistory(user);
    }
    loadUserSessions(user) {
        this.sessionToReschedule = null;
        this.session = null;
        this.sessionService.getSessionsByUserId(user.id, true).subscribe((sessions) => {
            var _a, _b;
            if (((_a = this.selectedUser) === null || _a === void 0 ? void 0 : _a.id) === user.id) { // make sure the selected user isn't changed meanwhile the request
                // getAll=true will fetch all session, no matter what is the session statue,
                // filter the cancelled and rescheduled sessions
                this.selectedUserSessions = sessions.body
                    .filter(s => !s.cancelled && !s.rescheduled)
                    .sort((a, b) => a.sessionStartTime.minutes() - b.sessionStartTime.minutes());
                const endedSessions = this.selectedUserSessions
                    .filter(s => s.ended);
                this.upcomingSession = this.selectedUserSessions.filter(s => s.future)[0];
                this.session = this.sessionService.decideWhichSessionToDisplay(this.selectedUserSessions, endedSessions);
                if (!this.session && ((_b = sessions === null || sessions === void 0 ? void 0 : sessions.body) === null || _b === void 0 ? void 0 : _b.length)) {
                    // use last session, it can be a cancelled session
                    this.session = sessions.body[sessions.body.length - 1];
                }
                console.log('selected session is: ' + this.session.id);
                if (!this.isScreenLg) { // if it's mobile view and a conversation is selected
                    if (this.session || this.upcomingSession) {
                        this.viewMode = 'UserInfo'; // show user info for mobile view
                    }
                }
            }
        });
    }
    switchLeftColumnTab(selectedTab) {
        this.leftColumnTab = selectedTab;
    }
    switchRightColumnTab(selectedTab) {
        this.rightColumnTab = selectedTab;
    }
    selectSessionToReschedule(sessionToReschedule) {
        if (this.selectedUser && this.selectedUser.id === sessionToReschedule.user.id) {
            this.sessionToReschedule = sessionToReschedule;
        }
        if (!this.isScreenLg) {
            this.viewMode = 'UserInfo';
        }
    }
    navigateToSession() {
        let session;
        if (this.session) {
            session = this.session;
        }
        else if (this.upcomingSession) {
            session = this.upcomingSession;
        }
        this.sessionStatusManagerService.navigateToSession(session);
    }
    showPreviousSessionTranscriptInThisTab(session) {
        this.previousSessionToShowTranscript = session;
        this.ngbModalRef = this.modalService.open(this.previousSessionTranscriptModal, { size: 'xl' });
    }
    showPreviousSessionTranscriptInNewTab(session) {
        // this.router.navigate(['/past',session.id]);
        this.router.navigate([]).then(() => { window.open('/#/past/' + session.id, '_blank'); });
    }
    onResourceSelected($event) {
        this.message = '';
        setTimeout(() => {
            this.message = $event.resource;
        }, 0);
    }
    goToLink(link) {
        window.open(link, '_blank');
    }
}
IndexCoachComponent.ɵfac = function IndexCoachComponent_Factory(t) { return new (t || IndexCoachComponent)(i0.ɵɵdirectiveInject(i1.SessionService), i0.ɵɵdirectiveInject(i2.ActionPlanService), i0.ɵɵdirectiveInject(i3.JhiEventManager), i0.ɵɵdirectiveInject(i4.SessionStorageService), i0.ɵɵdirectiveInject(i5.NgbModal), i0.ɵɵdirectiveInject(i6.OfflineMessageService), i0.ɵɵdirectiveInject(i7.UserService), i0.ɵɵdirectiveInject(i8.ConversationnService), i0.ɵɵdirectiveInject(i9.MessageService), i0.ɵɵdirectiveInject(i10.TranslateService), i0.ɵɵdirectiveInject(i3.JhiAlertService), i0.ɵɵdirectiveInject(i11.SRQCompletedService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i12.Router), i0.ɵɵdirectiveInject(i13.NavbarInukaService), i0.ɵɵdirectiveInject(i14.SessionStatusManagerService), i0.ɵɵdirectiveInject(i15.TimeZoneService), i0.ɵɵdirectiveInject(i16.PwaInstallationService)); };
IndexCoachComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: IndexCoachComponent, selectors: [["index-coach"]], viewQuery: function IndexCoachComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
        i0.ɵɵviewQuery(_c1, 5);
        i0.ɵɵviewQuery(_c2, 5);
        i0.ɵɵviewQuery(_c3, 5, ViewContainerRef);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.emailSessionMessagesModal = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.previousSessionTranscriptModal = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.upcomingSessionBoxElement = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.mobileViewEmbeddedComponentContainer = _t.first);
    } }, outputs: { messageSent: "messageSent" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 37, vars: 30, consts: [[1, "olha-theme", 3, "hidden"], [1, "px-3", 2, "height", "100vh", "padding-top", "85px"], [1, "row", "d-xl-none", "bg-1", "justify-content-center", "mb-3", 2, "border-radius", "0", "margin-top", "-25px"], ["mobileViewEmbeddedComponentContainer", ""], [1, "row", "justify-content-center", 2, "position", "relative", "height", "95%"], [1, "col-12", "col-lg-4", "col-xl-3", "pr-lg-0", "pr-xl-4", "h-100"], [1, "flex-column", "p-0"], [1, "row", "m-0"], [1, "col", "pb-4", "px-0"], ["showLeftArrow", "true", "minimized", "true", "showUserCreditAlert", "true", 3, "user", "session", "srqHistory", "onLeftArrowClick"], [1, "mt-2", 2, "border-top", "1px solid #7CBFAE"], [1, "mt-3", "px-4"], [3, "user", "coach", "session", "sessionToReschedule", "onSessionSchedulerToggle"], ["class", "btn btn-success mt-3 w-100", 3, "d-none", "d-block", "click", 4, "ngIf"], [1, "h-100", "flex-column", "p-0"], [1, "col", "px-2", "py-3", "tab", 2, "border-radius", "20px 0 0 0", 3, "click"], [1, "mb-0", "w-100", "text-center"], [1, "col", "px-2", "py-3", "tab", 2, "border-radius", "0 20px 0 0", 3, "click"], ["jhiTranslate", "inukaNgApp.indexUser.upcoming", 1, "mb-0", "w-100", "text-center"], [1, "m-0"], [1, "row", "h-100", "m-0"], [1, "col", "h-100", "p-0"], [3, "scrolledToBottom", "selectedConv"], [3, "newSession", "onPersistentSessionEmitted", "onSessionItemSelected", "onSessionSelectedForReschedule"], ["class", "col-12 col-lg-4 col-xl-5 h-100", 4, "ngIf"], ["class", "col-12 col-lg-4 col-xl-3 pl-lg-0 pl-xl-4 h-100", 4, "ngIf"], [4, "ngIf"], ["emailSessionMessagesModal", ""], ["previousSessionTranscriptModal", ""], [1, "btn", "btn-success", "mt-3", "w-100", 3, "click"], [1, "col-12", "col-lg-4", "col-xl-5", "h-100"], ["centerColumnElement", ""], [1, "pb-4"], ["centerUserInfoElement", ""], [1, "flex-column"], [1, "row"], [1, "col"], ["showUserCreditAlert", "true", 3, "user", "srqHistory", "session"], ["class", "mb-0 flex-column", 3, "ngStyle", 4, "ngIf"], [1, "mb-0", "flex-column", 3, "ngStyle"], [1, "row", "m-0", "justify-content-between"], [1, "col", "bg-1", "chat-ui-header", "py-2"], [2, "position", "relative", "top", "0.6rem"], [3, "session", "hideCancelReschedule", "resourceSelected"], [1, "info-row"], [1, "d-flex", "align-items-center", "justify-content-between", "pr-3"], [3, "session"], ["id", "user-home-expand-chat-btn", 2, "cursor", "pointer", 3, "routerLink", "matTooltip", "matTooltipPosition", "matTooltipClass"], [1, "expand", 2, "width", "1.1rem!important", "height", "1.1rem!important"], [0, "xlink", "href", "../../../../../../content/images/sprite.svg?v=3#expand"], [2, "position", "absolute", "left", "0", "right", "0", "height", "calc(100% - 80px)"], ["chatContainer", ""], [3, "ngStyle"], [1, "chat-container", "p-1", 3, "session", "viewportHeight", "scrolledToBottom", "repliedMessage", "firstSessionMessageOutput"], ["messageSendContainer", ""], [3, "session", "message", "messageToBeReplied", "maxCharacterSize", 4, "ngIf"], ["class", "alert alert-warning m-0", "jhiTranslate", "inukaNgApp.indexUser.coachIsNotAllowedSendMessageToUser", 4, "ngIf"], [3, "session", "message", "messageToBeReplied", "maxCharacterSize"], ["jhiTranslate", "inukaNgApp.indexUser.coachIsNotAllowedSendMessageToUser", 1, "alert", "alert-warning", "m-0"], [1, "col-12", "col-lg-4", "col-xl-3", "pl-lg-0", "pl-xl-4", "h-100"], [1, "h-100"], ["rightColumnElement", ""], ["upcomingSessionBoxElement", ""], [1, "flex-column", 2, "overflow-y", "auto", "overflow-x", "hidden"], [1, "col", "p-4"], ["class", "d-flex flex-column pb-4", 3, "ngStyle", 4, "ngIf"], [1, "d-flex", "flex-column", "pb-4", 3, "ngStyle"], [1, "col", "px-2", "py-3", "tab", 3, "click"], ["jhiTranslate", "inukaNgApp.inukaJourney.journey", 1, "mb-0", "w-100", "text-center"], ["jhiTranslate", "sessionChat.button.actionPlan", 1, "mb-0", "w-100", "text-center", 2, "color", "var(--main)"], ["jhiTranslate", "sessionChat.button.notes", 1, "mb-0", "w-100", "text-center"], [1, "row", 2, "height", "100%", "overflow-y", "scroll"], [1, "flex-grow-1", "col", "py-2", "pl-4", 2, "overflow", "hidden"], [3, "sessions", "srqHistory", "sessionSelectedToOpenInThisTab", "sessionSelectedToOpenInNewTab", 4, "ngIf"], [3, "userId", 4, "ngIf"], ["style", "height: 100%", 4, "ngIf"], [3, "sessions", "srqHistory", "sessionSelectedToOpenInThisTab", "sessionSelectedToOpenInNewTab"], [3, "userId"], [2, "height", "100%"], [1, "d-flex", "align-items-center", "justify-content-end", "pr-4", 2, "cursor", "pointer"], [1, "expand-div", 3, "matTooltip", "matTooltipPosition", "matTooltipClass", "click"], [1, "expand", 2, "width", "1.2rem!important", "height", "1.2rem!important"], ["height", "100%", 3, "isEmbedded", "coachId", "userId"], [3, "titleText", "message"], [1, "olha-theme"], [1, "d-flex", "justify-content-end"], ["icon", "times-circle", 1, "mt-3", "mr-3", 2, "cursor", "pointer", 3, "click"], [1, "modal-body", 2, "height", "830px"], [3, "showInModal", "session"]], template: function IndexCoachComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementContainer(3, null, 3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "div", 4);
        i0.ɵɵelementStart(6, "div", 5);
        i0.ɵɵelementStart(7, "div", 6);
        i0.ɵɵelementStart(8, "div", 7);
        i0.ɵɵelementStart(9, "div", 8);
        i0.ɵɵelementStart(10, "div");
        i0.ɵɵelementStart(11, "user-info", 9);
        i0.ɵɵlistener("onLeftArrowClick", function IndexCoachComponent_Template_user_info_onLeftArrowClick_11_listener() { return ctx.viewMode = "All"; });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelement(12, "hr", 10);
        i0.ɵɵelementStart(13, "div", 11);
        i0.ɵɵelementStart(14, "upcoming-session", 12);
        i0.ɵɵlistener("onSessionSchedulerToggle", function IndexCoachComponent_Template_upcoming_session_onSessionSchedulerToggle_14_listener($event) { return ctx.showSessionScheduler = $event; });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(15, IndexCoachComponent_button_15_Template, 2, 4, "button", 13);
        i0.ɵɵelementStart(16, "div", 14);
        i0.ɵɵelementStart(17, "div", 7);
        i0.ɵɵelementStart(18, "div", 15);
        i0.ɵɵlistener("click", function IndexCoachComponent_Template_div_click_18_listener() { return ctx.switchLeftColumnTab("chats"); });
        i0.ɵɵelementStart(19, "h5", 16);
        i0.ɵɵtext(20, "Chats");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(21, "div", 17);
        i0.ɵɵlistener("click", function IndexCoachComponent_Template_div_click_21_listener() { return ctx.switchLeftColumnTab("upcomingSessions"); });
        i0.ɵɵelement(22, "h5", 18);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelement(23, "hr", 19);
        i0.ɵɵelementStart(24, "div", 20);
        i0.ɵɵelementStart(25, "div", 21);
        i0.ɵɵelementStart(26, "conversation-list", 22);
        i0.ɵɵlistener("selectedConv", function IndexCoachComponent_Template_conversation_list_selectedConv_26_listener($event) { return ctx.setSelectedUser($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(27, "div", 20);
        i0.ɵɵelementStart(28, "div", 21);
        i0.ɵɵelementStart(29, "upcoming-sessions", 23);
        i0.ɵɵlistener("onPersistentSessionEmitted", function IndexCoachComponent_Template_upcoming_sessions_onPersistentSessionEmitted_29_listener($event) { return ctx.getPersistentSessionEmitted($event); })("onSessionItemSelected", function IndexCoachComponent_Template_upcoming_sessions_onSessionItemSelected_29_listener($event) { return ctx.getSessionItemSelected($event); })("onSessionSelectedForReschedule", function IndexCoachComponent_Template_upcoming_sessions_onSessionSelectedForReschedule_29_listener($event) { return ctx.selectSessionToReschedule($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(30, IndexCoachComponent_div_30_Template, 9, 4, "div", 24);
        i0.ɵɵtemplate(31, IndexCoachComponent_div_31_Template, 10, 7, "div", 25);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(32, IndexCoachComponent_pwa_installation_ios_32_Template, 1, 0, "pwa-installation-ios", 26);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(33, IndexCoachComponent_ng_template_33_Template, 2, 4, "ng-template", null, 27, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(35, IndexCoachComponent_ng_template_35_Template, 5, 2, "ng-template", null, 28, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        i0.ɵɵproperty("hidden", !ctx.display && ctx.conversationCount !== 0);
        i0.ɵɵadvance(7);
        i0.ɵɵclassProp("d-none", ctx.viewMode !== "UserInfo")("d-flex", ctx.viewMode === "UserInfo");
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("user", ctx.selectedUser)("session", ctx.session)("srqHistory", ctx.srqHistory);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("user", ctx.selectedUser)("coach", ctx.currentCoach)("session", ctx.upcomingSession)("sessionToReschedule", ctx.sessionToReschedule);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.showSessionScheduler);
        i0.ɵɵadvance(1);
        i0.ɵɵclassProp("d-none", ctx.viewMode !== "All")("d-flex", ctx.viewMode === "All");
        i0.ɵɵadvance(2);
        i0.ɵɵclassProp("selected-tab", ctx.leftColumnTab === "chats");
        i0.ɵɵadvance(3);
        i0.ɵɵclassProp("selected-tab", ctx.leftColumnTab === "upcomingSessions");
        i0.ɵɵadvance(3);
        i0.ɵɵclassProp("d-none", ctx.leftColumnTab !== "chats");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("scrolledToBottom", ctx.scrolledToBottom);
        i0.ɵɵadvance(1);
        i0.ɵɵclassProp("d-none", ctx.leftColumnTab !== "upcomingSessions");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("newSession", ctx.newSession);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isScreenLg && ctx.selectedUser);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isScreenLg && ctx.selectedUser);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showPwaInstallation);
    } }, directives: [i17.UserInfoComponent, i18.UpcomingSessionComponent, i19.NgIf, i20.JhiTranslateDirective, i21.ConversationListComponent, i22.UpcomingSessionsComponent, i19.NgStyle, i23.SessionControlDropdownComponent, i24.InProgressVideoCallIndicatorComponent, i12.RouterLink, i25.MatTooltip, i26.ChatUiNewComponent, i27.SessionMessageSendComponent, i28.InukaJourneyCoachChatComponent, i29.ActionPlanListComponent, i30.CoachUserNoteComponent, i31.PwaInstallationIosComponent, i32.ModalSuccessComponent, i33.FaIconComponent, i34.PreviousSessionTranscriptPopupComponent], pipes: [i10.TranslatePipe], styles: [".container-coach[_ngcontent-%COMP%]{width:98%;margin-right:auto;margin-left:auto}.component-header[_ngcontent-%COMP%]{padding:10px 20px 0 20px;text-transform:uppercase;font-weight:bold;color:#000}.chat-ui-part[_ngcontent-%COMP%]{background-color:#fff;border:1px solid rgba(0,0,0,.1);border-radius:5px}.chat-ui-header[_ngcontent-%COMP%]{border-bottom-left-radius:0 !important;border-bottom-right-radius:0 !important}.info-row[_ngcontent-%COMP%]{display:grid;grid-auto-flow:column;padding:0px;min-height:40px}.link[_ngcontent-%COMP%]{font-weight:bold;color:#4ab197;float:right;margin:10px 30px 0 30px}.action-plan-top-position[_ngcontent-%COMP%]{top:900px}.chat-container[_ngcontent-%COMP%]{flex:auto}@media(min-width: 576px){.container-coach[_ngcontent-%COMP%]{width:90%;margin-right:auto;margin-left:auto}}@media(min-width: 768px){.container-coach[_ngcontent-%COMP%]{width:98%;margin-right:auto;margin-left:auto}.action-plan-top-position[_ngcontent-%COMP%]{top:50px}}@media(min-width: 1300px){.container-coach[_ngcontent-%COMP%]{width:90%;margin-right:auto;margin-left:auto}}.flex-column[_ngcontent-%COMP%]{background-color:#fff;border-radius:20px;position:relative !important}.tab[_ngcontent-%COMP%]{cursor:pointer}.tab[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%]{color:var(--main)}.selected-tab[_ngcontent-%COMP%]{background-color:var(--main);border-radius:20px 20px 0 0}.selected-tab[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%]{color:#fff !important}"] });
